var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { decodeBase64, encodeBase64 } from "./base64";
/* eslint-disable compat/compat */
class GzipCodec {
    constructor() {
        this.format = "gzip";
    }
    get canCompress() {
        return "CompressionStream" in self;
    }
    get canDecompress() {
        return "DecompressionStream" in self;
    }
    load(useCompress, useDecompress) {
        return __awaiter(this, void 0, void 0, function* () {
            // Browser support check
            if ((!useCompress && !useDecompress) ||
                !("CompressionStream" in self && "DecompressionStream" in self)) {
                console.error("Browser doesn't support native (De)CompressionStream.");
            }
        });
    }
    compress(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const encoder = new TextEncoder();
                const readableStream = new ReadableStream({
                    start(controller) {
                        controller.enqueue(encoder.encode(data));
                        controller.close();
                    },
                });
                const compressionStream = new CompressionStream("gzip");
                const compressedStream = readableStream.pipeThrough(compressionStream);
                const response = new Response(compressedStream);
                return new Uint8Array(yield response.arrayBuffer());
            }
            catch (ex) {
                console.error("Failed to compress data using Gzip:", ex === null || ex === void 0 ? void 0 : ex.message);
                return null;
            }
        });
    }
    compressEncoded(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const compressedData = yield this.compress(data);
                return compressedData ? encodeBase64(compressedData) : null;
            }
            catch (ex) {
                return null;
            }
        });
    }
    /** a string in base64 */
    decompress(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const bytes = decodeBase64(data);
                const decompressionStream = new DecompressionStream("gzip");
                const decompressedStream = new ReadableStream({
                    start(controller) {
                        controller.enqueue(bytes);
                        controller.close();
                    },
                }).pipeThrough(decompressionStream);
                const response = new Response(decompressedStream);
                return yield response.text();
            }
            catch (ex) {
                console.error("Failed to decompress data using Gzip:", ex === null || ex === void 0 ? void 0 : ex.message);
                return null;
            }
        });
    }
}
export const Gzip = new GzipCodec();
